import { render, staticRenderFns } from "./UrlForm.vue?vue&type=template&id=d6798442&scoped=true"
import script from "./UrlForm.vue?vue&type=script&lang=js"
export * from "./UrlForm.vue?vue&type=script&lang=js"
import style0 from "./UrlForm.vue?vue&type=style&index=0&id=d6798442&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d6798442",
  null
  
)

export default component.exports